"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerseClaimController = void 0;
var ethers_1 = require("ethers");
var utils_1 = require("ethers/lib/utils");
var VerseClaimer_1 = require("../../contracts/VerseClaimer");
var Result_1 = __importDefault(require("../../Result"));
var errors_1 = require("./errors");
var neko_1 = require("../../services/neko");
/**
 * Verse Claim controller. Handle claim contract function calls
 */
var VerseClaimController = /** @class */ (function () {
    function VerseClaimController(library, claimerContract) {
        this._signer = library.getSigner();
        this._claimContract = new ethers_1.Contract(claimerContract, new utils_1.Interface(VerseClaimer_1.ABI.abi), this._signer);
    }
    /**
     * Gets keeperList with the address given
     *
     * @returns KeeperListResponse - can determine available/claimed tokens
     */
    VerseClaimController.prototype.getKeeperList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var address, keeperList, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this._signer.getAddress()];
                    case 1:
                        address = _a.sent();
                        return [4 /*yield*/, this._claimContract.keeperList(address)];
                    case 2:
                        keeperList = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(keeperList)];
                    case 3:
                        error_1 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_GET_KEEPER_LIST)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Scrapes available tokens
     *
     * @returns ContractTransaction - transaction hash
     */
    VerseClaimController.prototype.scrapeTokens = function () {
        return __awaiter(this, void 0, void 0, function () {
            var transaction, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._claimContract.scrapeMyTokens()];
                    case 1:
                        transaction = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(transaction)];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_SCRAPE_TOKENS)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Enrolls address and scrapes available tokens
     *
     * @returns ContractTransaction - transaction hash
     */
    VerseClaimController.prototype.enrollAndScrapeTokens = function () {
        return __awaiter(this, void 0, void 0, function () {
            var address, merkle, transaction, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this._signer.getAddress()];
                    case 1:
                        address = _a.sent();
                        return [4 /*yield*/, neko_1.neko.token.getMerkleProof(address)];
                    case 2:
                        merkle = _a.sent();
                        return [4 /*yield*/, this._claimContract.enrollAndScrape(merkle.index, merkle.locked, merkle.opened, merkle.timeFrame, merkle.proof)];
                    case 3:
                        transaction = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(transaction)];
                    case 4:
                        error_3 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_ENROLL_AND_SCRAPE_TOKENS)];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets available balance
     *
     * @returns balance - BigNumber
     */
    VerseClaimController.prototype.availableBalance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var address, balance, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this._signer.getAddress()];
                    case 1:
                        address = _a.sent();
                        return [4 /*yield*/, this._claimContract.availableBalance(address)];
                    case 2:
                        balance = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(balance)];
                    case 3:
                        error_4 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_AVAILABLE_BALANCE)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets the current date and time
     *
     * @returns dateTime - BigNumber
     */
    VerseClaimController.prototype.getNow = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dateTime, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._claimContract.getNow()];
                    case 1:
                        dateTime = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(dateTime)];
                    case 2:
                        error_5 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_GET_NOW)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets created date and time
     *
     * @returns dateTime - BigNumber
     */
    VerseClaimController.prototype.createTime = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dateTime, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._claimContract.createTime()];
                    case 1:
                        dateTime = _a.sent();
                        return [2 /*return*/, Result_1.default.ok(dateTime)];
                    case 2:
                        error_6 = _a.sent();
                        return [2 /*return*/, Result_1.default.fail(errors_1.ERROR_CREATE_TIME)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return VerseClaimController;
}());
exports.VerseClaimController = VerseClaimController;
